/**
 * 客户资料管理 API
 */
import http from './httpRequest.js'

/**
 * 上传文件
 */
export function uploadFile(formData) {
  return http({
    url: '/file/upload',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 获取客户列表
 */
export function getCustomerList(params) {
  return http({
    url: '/customer/list',
    method: 'GET',
    params
  })
}

/**
 * 获取客户详情
 */
export function getCustomerById(id) {
  return http({
    url: `/customer/${id}`,
    method: 'GET'
  })
}

/**
 * 新增客户
 */
export function addCustomer(data) {
  return http({
    url: '/customer',
    method: 'POST',
    data
  })
}

/**
 * 修改客户
 */
export function updateCustomer(data) {
  return http({
    url: '/customer',
    method: 'PUT',
    data
  })
}

/**
 * 删除客户
 */
export function deleteCustomer(ids) {
  return http({
    url: `/customer/${ids.join(',')}`,
    method: 'DELETE'
  })
}

/**
 * 导入客户
 */
export function importCustomers(data) {
  return http({
    url: '/customer/import',
    method: 'POST',
    data
  })
}

/**
 * 导入OCR识别客户
 */
export function importOcrCustomers(data) {
  return http({
    url: '/customer/importOcr',
    method: 'POST',
    data
  })
}

/**
 * 导入客户数据（表单上传）
 */
export function importCustomerData(formData) {
  return http({
    url: '/customer/importData',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 获取客户分配的员工列表
 */
export function getCustomerAssignments(customerId) {
  return http({
    url: `/customer/assignments/${customerId}`,
    method: 'GET'
  })
}

/**
 * 分配员工到客户
 */
export function assignUserToCustomer(customerId, userId) {
  return http({
    url: '/customer/assign',
    method: 'POST',
    data: { customerId, userId }
  })
}

/**
 * 取消分配
 */
export function unassignUserFromCustomer(customerId, userId) {
  return http({
    url: '/customer/unassign',
    method: 'DELETE',
    data: { customerId, userId }
  })
}

/**
 * 批量分配员工
 */
export function batchAssignUsers(customerIds, userIds) {
  return http({
    url: '/customer/batchAssign',
    method: 'POST',
    data: { customerIds, userIds }
  })
}

/**
 * 搜索用户
 */
export function searchUsers(keyword, excludeUserIds) {
  return http({
    url: '/customer/searchUsers',
    method: 'GET',
    params: { keyword, excludeUserIds: excludeUserIds ? excludeUserIds.join(',') : null }
  })
}

/**
 * 获取可分配用户列表
 */
export function getAssignableUsers(keyword) {
  return http({
    url: '/customer/assignableUsers',
    method: 'GET',
    params: { keyword }
  })
}

/**
 * 识别表格图片（OCR）
 */
export function recognizeTableImage(formData) {
  return http({
    url: '/customer/ocr/recognizeTableImage',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 上传行图片
 */
export function uploadRowImage(formData) {
  return http({
    url: '/customer/ocr/uploadRowImage',
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
